import { useMemo, useRef, useState } from 'react'

import { Experiments } from './Experiments'
import { ExperimentsContext } from './ExperimentsContext'

export const ExperimentsProvider = ({
  overrides,
  children,
}: {
  overrides?: Partial<Experiments>
  children: React.ReactNode
}) => {
  const [experiments] = useState<Experiments>(
    (typeof window !== 'undefined' ? window.experimentsJson : {}) as Experiments
  )

  const emittedAssignmentEvent = useRef({})

  const experimentData = useMemo(
    () => ({
      experiments: { ...experiments, ...overrides },
      emittedAssignmentEvent,
    }),
    [experiments, overrides]
  )

  return (
    <ExperimentsContext.Provider
      value={{
        ...experimentData,
      }}
    >
      {children}
    </ExperimentsContext.Provider>
  )
}
